import { render, staticRenderFns } from "./medicion-severidad-editar.vue?vue&type=template&id=7643c662&scoped=true&"
import script from "./medicion-severidad-editar.vue?vue&type=script&lang=js&"
export * from "./medicion-severidad-editar.vue?vue&type=script&lang=js&"
import style0 from "./medicion-severidad-editar.vue?vue&type=style&index=0&id=7643c662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7643c662",
  null
  
)

export default component.exports